import moment from "moment";
import { Attachment } from "shared/models/ProcessTemplate";
import { deepCopyFrom } from "shared/services/deepCopyFrom";

export function trimObject(obj) {
	if (!Array.isArray(obj) && typeof obj != "object") return obj;
	if (Array.isArray(obj)) return obj.map((x) => trimObject(x));
	return Object.keys(obj).reduce(
		function (acc, key) {
			if (typeof obj[key] == "string") {
				acc[key.trim()] = obj[key].trim();
			} else {
				if (obj[key] == null) acc[key.trim()] = "";
				else acc[key.trim()] = trimObject(obj[key]);
			}
			return acc;
		},
		Array.isArray(obj) ? [] : {}
	);
}

export function clamp(value, a, b) {
	return value < a ? a : value > b ? b : value;
}

/** Changes an element's position in the array */
export const arrayMove = (arr: any[], from: number, to: number) => {
	arr.splice(to, 0, arr.splice(from, 1)[0]);
};

export function SimpleDate(utcDate: Date) {
	return `${utcDate.getDate()} ${utcDate.toLocaleString("default", {
		month: "short",
	})}. ${utcDate.getFullYear()}`;
}

export const reorderAttachments = (arr: Attachment[], from: number, to: number): Attachment[] => {
	const arrCopy = deepCopyFrom(arr) as Attachment[];
	for (let i = 0; i < arr.length; i++) {
		const a = arr[i];
		const b = arrCopy[i];
		const movedDown = from > to;

		const insideRange =
			Number.isInteger(a.stepIndex) &&
			((movedDown && a.stepIndex! >= to && a.stepIndex! <= from) ||
				(!movedDown && a.stepIndex! <= to && a.stepIndex! >= from));

		if (!insideRange) continue;
		if (a.stepIndex == from) {
			b.stepIndex = to;
			continue;
		}
		b.stepIndex! += movedDown ? 1 : -1;
	}
	return arrCopy;
};
